import makeStyles from '@mui/styles/makeStyles';

export const useMainScreenButtonStyles = makeStyles((theme) => {
    return ({
        background: {
            backgroundColor: theme.palette.background.paperDarker,
            border: `1px solid transparent`,
            borderRadius: 10,
            boxShadow: `0px ${theme.palette.mode === 'light' ? 4 : 0}px ${theme.palette.mode === 'light' ? 4 : 0}px 0px rgba(0, 0, 0, 0.25)`,
            '&:hover': {
                borderColor: theme.palette.acuityColors.color5.background,
            },
            '&.disabled': {
                '&:hover': {
                    borderColor: theme.palette.background.paperHover,
                },
            },
        },
        addButton: {
            marginTop: 10,
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            '&.disabled': {
                color: theme.palette.secondary.main,
                borderColor: theme.palette.secondary.main,
            },
        },
        divRow: {
            display: 'flex',
            flexWrap: 'nowrap',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 5,
        },
        buttonHeader: {
            display: 'flex',
            backgroundColor: theme.palette.background.paperDarker,
            // justifyContent: 'space-between',
            alignItems: 'center',
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            paddingBottom: 5,
            '& .noPaddingLeft': {
                paddingLeft: 0,
            },
        },
        buttonHeaderFilled: {
            backgroundColor: theme.palette.mainScreenButton.headerFilled,
            paddingLeft: 10,
            paddingRight: 10,
            display: 'flex',
            justifyContent: 'space-between',
        },
        formFilledDetails: {
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
            overflow: 'hidden',
            '& .notFilled': {
                backgroundColor: theme.palette.background.paperDarker,
            },
        },
        seenDlg: {
            backgroundColor: theme.palette.background.paperDarker,
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
            '& .label-set': {
                paddingBottom: 0,
                paddingTop: 1,
                backgroundColor: theme.palette.mainScreenButton.formFilledDetails,
                textTransform: 'none !important',
                maxHeight: 'min-content',
                height: '100%',
                '& .label-part1': {
                    textTransform: 'uppercase',
                },
                '& .label-part2': {
                    fontWeight: 'normal',
                    margin: '0 10px',
                    wordBreak: 'break-word',
                },
                '& .label-part3': {
                    opacity: .7,
                    whiteSpace: 'break-spaces',
                },
            },
            '& .notFilled': {
                backgroundColor: theme.palette.background.paperDarker,
            },
            '& .noPadding': {
                backgroundColor: theme.palette.mainScreenButton.formFilledDetails,
            },
            '& .filledBackground': {
                backgroundColor: theme.palette.mainScreenButton.formFilledDetails,
            },
            '& .not-set': {},
            '& .not-set-not-mandatory': {},
        },
        draftButton: {
            color: '#fff',
            border: '10px #FFBF00',
            borderStyle: 'solid none',
        },
        timeStampButton: {
            border: '10px red',
            borderStyle: 'solid none',
        },
        editButton: {
            '&:hover': {
                cursor: 'pointer',
            },
        },
        '.buttonHeaderFilled:hover > .editButton': {
            textDecoration: 'underline',
            '& .editButton:hover': {},
        },
        loadingSpinner: {
            display: 'contents',
        },
    });
});